<template>
    <!-- Control Menu -->
    
    <div class="d-flex align-items-center  justify-content-between  footer mt-4">

        <feather-icon @click="previous()" class="text-white ml-2" icon="ChevronLeftIcon" size="35" />
        <b-link :to="{ name: 'home' }" ><!--class="ml-2">-->
            <feather-icon class="text-white  justify-content-center" icon="HomeIcon" size="35" />
        </b-link>
        <feather-icon v-b-toggle.sidebar-right class="text-white mr-2" icon="MenuIcon" size="35" />
         <b-sidebar id="sidebar-right" style="z-index:999 !important;" bg-variant="white" right backdrop shadow>
            <v-offline 
            @detected-condition="onConnectionChange">
                
            </v-offline>
            <sidebar-content/>
            <template #footer="{ hide }">
                <div class="d-flex align-items-center px-3 py-2">
                    <b-button @click="syncData" class="mr-auto bg-primary" :disabled="!online">Sincronizar Datos</b-button>     
                </div>
                <div class="d-flex align-items-center px-3 py-2">
                    <b-button  @click="logout" class="bg-danger">Cerrar Sesión</b-button>                
                </div>
                <div class="d-flex align-items-center px-3 py-2">
                    <small>V. 1.0.87</small>  
                </div>
            </template>
        </b-sidebar>
    </div>
</template>
<script>
import { BLink, BSidebar, VBToggle, BButton } from 'bootstrap-vue'
import router from 'vue-router'
import SidebarContent from './SidebarContent.vue';
import { VOffline } from 'v-offline';
import axios from 'axios';

export default {
    components: {
        BLink,
        BButton,
        router,
        BSidebar,
        SidebarContent,
        VOffline
    },
    directives: {
        'b-toggle': VBToggle,
    },
    data() {
        return {
            isSidebarVisible: false,
            online:false,
        }
    },
    methods: {

        previous: () => {
            console.log(history)
            //let goba= parseInt(history.length-1);
            //history.go(goba);
            history.back();
            return false;
        },
        logout(){
            localStorage.clear();
            this.$router.push('/login');
        },
        onConnectionChange(status) {
            this.online=status;
            console.log(status);
        },
        syncData(){
            let self=this;
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            //Insert animal
            let animalData = JSON.parse(localStorage.getItem('animalCreate'));
            
            if(typeof animalData!=='undefined'){
                this.$http.post("add/animals", animalData, config).then(()=>{
                    localStorage.removeItem('animalCreate');
                    
                }).catch(error => {
                    console.log(error)
                });
            }

            //Insert weighins
            let wheighinsData = JSON.parse(localStorage.getItem('weighinsInsert'))
            if(typeof wheighinsData!=='undefined'){
                var request= wheighinsData.map(items =>this.$http.post("add/weighins", items, config));
                axios.all(request).then(()=>{
                    localStorage.removeItem('weighinsInsert');
                }).catch(error=>{
                    console.log(error)
                });
            }
            

            self.$swal({
                title: 'Sincronización de datos',
                text: 'Se sincronizaron los datos de manera satisfactoria',
                type: 'success',
                icon:'success',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
            });
            
        }
    },
    mounted(){
        this.online=navigator.onLine;
    },
}
</script>
<style lang="scss">
.footer {
    height: 50px;
    left: 1px;
    position: fixed;
    bottom: 0px;
    right: 0px;
    background: #5E8F23;
    box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.57);
    border-radius: 10px 10px 0px 0px;
}
</style>